<template>
  <v-container>
    <div class="pa-3 display-1">
      メンテナンスメニュー
    </div>

    <v-row align="center" justify="center" dense>
      <v-col cols="12" xl="12" dense>
        <v-card v-if= "!isSystemAdmin" flat outlined class="ma-5 pa-3">
          <div class="subtitle-2 mb-2">
            <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
            <span class="primary--text">メンテナンス機能について</span>
          </div>
          <p class="caption">
              この機能はシステム管理者のみ利用できる機能です。<br>
          </p>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if= "isSystemAdmin" align="center" justify="center" dense>
      <v-col cols="12" xl="12" dense>
        <v-btn icon :to="{ path: '/mainteanalizeset' }">
          <v-icon>mdi-flask-empty-plus </v-icon>
        </v-btn><span @click="$router.push('/mainteanalizeset')" style="cursor: pointer;">分析セット（プロトコルマスタ）管理</span>
      </v-col>
    </v-row>

    <v-row v-if= "isSystemAdmin" align="center" justify="center" dense>
      <v-col cols="12" xl="12" dense>
        <v-btn icon :to="{ path: '/mainteanalizeitem' }">
          <v-icon>mdi-flask-empty </v-icon>
        </v-btn><span @click="$router.push('/mainteanalizeitem')" style="cursor: pointer;">分析項目（ホルダマスタ）管理</span>
      </v-col>
    </v-row>

    <v-row v-if= "isSystemAdmin" align="center" justify="center" dense>
      <v-col cols="12" xl="12" dense>
        <v-btn icon :to="{ path: '/mainteinformation' }">
          <v-icon>mdi-information-outline  </v-icon>
        </v-btn><span @click="$router.push('/mainteinformation')" style="cursor: pointer;">お知らせ管理</span>
      </v-col>
    </v-row>

    <v-row v-if= "isSystemAdmin" align="center" justify="center" dense>
      <v-col cols="12" xl="12" dense>
        <v-btn icon :to="{ path: '/mainteoutbox' }">
          <v-icon>mdi-email</v-icon>
        </v-btn><span @click="$router.push('/mainteoutbox')" style="cursor: pointer;">送信メールボックス一覧</span>
      </v-col>
    </v-row>

    <v-row v-if= "isSystemAdmin" align="center" justify="center" dense>
      <v-col cols="12" xl="12" dense>
        <v-btn icon :to="{ path: '/maintedeliverables' }">
          <v-icon>mdi-file-document-multiple</v-icon>
        </v-btn><span @click="$router.push('/maintedeliverables')" style="cursor: pointer;">納品明細書・報告書管理</span>
      </v-col>
    </v-row>

    <v-row v-if= "isSystemAdmin" align="center" justify="center" dense>
      <v-col cols="12" xl="12" dense>
        <v-btn icon :to="{ path: '/maintecompany' }">
          <v-icon>mdi-office-building</v-icon>
        </v-btn><span @click="$router.push('/maintecompany')" style="cursor: pointer;">得意先一覧（β）</span>
      </v-col>
    </v-row>

    <v-row v-if= "isSystemAdmin" align="center" justify="center" dense>
      <v-col cols="12" xl="12" dense>
        <v-btn icon :to="{ path: '/mainteemployee' }">
          <v-icon>mdi-account-group</v-icon>
        </v-btn><span @click="$router.push('/mainteemployee')" style="cursor: pointer;">Web利用者一覧（β）</span>
      </v-col>
    </v-row>


    <v-row v-if= "isSystemAdmin" align="center" justify="center" dense>
      <v-col cols="12" xl="12" dense>
        <v-btn icon :to="{ path: '/maintenstatistics' }">
          <v-icon>mdi-chart-bar</v-icon>
        </v-btn><span @click="$router.push('/maintenstatistics')" style="cursor: pointer;">統計情報ダッシュボード（β）</span>
      </v-col>
    </v-row>
    <v-row align="center" justify="center" v-if="isDeveloper" dense>
      <v-col cols="12" xl="12" dense>
        <v-btn icon :to="{ path: '/maintenance01' }">
          <v-icon>mdi-information-outline  </v-icon>
        </v-btn><span @click="$router.push('/maintenance01')" style="cursor: pointer;">開発用テストツール</span>
      </v-col>
    </v-row>

</v-container>
</template>

<script>

export default {

  name: "MaintenanceMenu",
  mixins:[],
  head: {
    title: { inner: 'メンテナンスメニュー'},
  },
  data() {
    return {
    };
  },
  filters: {
  },
  computed: {
    isDeveloper() {
      return this.$store.state.isDeveloper
    },
    isAdmin () {
      return this.$store.state.isAdmin
    },
    isSystemAdmin : function() {
      return this.$store.state.isSystemAdmin
    },
  },
  mounted: async function () {

  },
  methods: {
  }
};
</script>
